import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';

/**
 * Renders recently viewed product cards on the product page.
 * @extends {Component<{ grid: HTMLElement }>}
 */
class RecentlyViewedSection extends Component {
  requiredRefs = ['grid'];

  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  #render() {
    const currentId = this.dataset.productId;
    const records = RecentlyViewed.getProductRecords().filter(
      (item) => String(item.id) !== String(currentId) && item.title
    );

    if (records.length === 0) {
      this.hidden = true;
      return;
    }

    const { grid } = this.refs;
    if (!(grid instanceof HTMLElement)) return;

    grid.replaceChildren();

    for (const item of records.slice(0, 4)) {
      const card = document.createElement('a');
      card.className = 'recently-viewed-section__card';
      card.href = item.url || `/products/${item.handle}`;

      if (item.image) {
        const image = document.createElement('img');
        image.className = 'recently-viewed-section__image';
        image.src = item.image;
        image.alt = item.title || '';
        image.loading = 'lazy';
        image.width = 600;
        image.height = 750;
        card.appendChild(image);
      }

      const title = document.createElement('span');
      title.className = 'recently-viewed-section__title';
      title.textContent = item.title || '';
      card.appendChild(title);

      if (item.price) {
        const price = document.createElement('span');
        price.className = 'recently-viewed-section__price';
        price.textContent = item.price;
        card.appendChild(price);
      }

      grid.appendChild(card);
    }

    this.hidden = false;
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
